import React, { useEffect, useState } from 'react'
import { BaseLayout } from 'src/layouts'
import styles from './styles.module.scss'
import { AuthorList } from './components/AuthorList'
import { useAuthor, useNewsArticles } from 'src/state'
import { WEBSITE } from 'src/consts'
import { LastNewArticles } from '../NewsArticleDetails/components/LastNewsArticles'

const formatList = data => {
  const itemParse = {}

  data?.map(item => {
    const index = item.slug

    if (!itemParse[index]) {
      itemParse[index] = []
    }

    itemParse[index].push({
      fullName: item.attributes.fullName,
      shortDescription: item.attributes.shortDescription,
      slug: item.attributes.slug,
      email: item.attributes.email,
      bio: item.attributes.bio,
      image: item.attributes.image?.data?.attributes?.url,
    })
  })

  return { data: itemParse }
}

export const Author = () => {
  const authorData = formatList(useAuthor().data)
  const keys = Object.keys(authorData.data)
  const [itemActive] = useState('')
  const lastNewsArticles = useNewsArticles({
    page: 1,
    pageSize: 5,
  }).data?.data

  const [dataFilter, setDataFilter] = useState(authorData.data)
  const [search, setSearch] = useState('')

  useEffect(() => {
    if (search) {
      const dataFilter = keys.reduce((acc, key) => {
        const data = authorData.data[key].filter(item => {
          return item.title.toLowerCase().includes(search.toLowerCase())
        })
        return { ...acc, [key]: data }
      }, {})

      setDataFilter(
        Object.entries(dataFilter)
          .filter(([, value]) => value)
          .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {})
      )
    } else {
      setDataFilter(authorData.data)
    }
  }, [search])

  useEffect(() => {
    if (itemActive === '') {
      setDataFilter(authorData.data)
    } else {
      const newData = authorData.data[itemActive]
      setDataFilter({ [itemActive]: newData })
      setSearch('')
    }
  }, [itemActive])

  return (
    <div className={styles.container}>
      <div className={styles.mainContent}>
        <h1>Authors at Coin360</h1>
        <h2>The Voices Shaping Crypto Insights and Reviews</h2>
        <AuthorList data={dataFilter} />
      </div>
      {lastNewsArticles && (
        <div className={styles.rightColumn}>
          <LastNewArticles
            className={styles.lastNewsArticles}
            newsArticles={lastNewsArticles}
          />
        </div>
      )}
    </div>
  )
}

const AuthorLayout = ({ children }) => {
  return (
    <BaseLayout
      scrollInContent
      seo={{
        title: 'Coin360 Authors: Top Crypto Writers & Analysts',
        description:
          'Meet Coin360s expert crypto writers. Explore top news, insights, and analyses from our leading crypto professionals.',
        canonical: `${WEBSITE}/author`,
      }}
    >
      {children}
    </BaseLayout>
  )
}

Author.getLayout = AuthorLayout
